import { NotificationContentErrorTypes } from '../notification-content.errors';
import { NotificationContentAction } from '../types';

export const getNotificationContentErrorType = (
  error: any,
  action: NotificationContentAction,
): NotificationContentErrorTypes => {
  if (!error) return null;

  switch (action) {
    case 'publish':
      return error.status === 404
        ? NotificationContentErrorTypes.NotificationContentPublishNotFoundError
        : NotificationContentErrorTypes.NotificationContentPublishError;
    case 'delete':
      return error.status === 404
        ? NotificationContentErrorTypes.NotificationContentDeleteNotFoundError
        : NotificationContentErrorTypes.NotificationContentDeleteError;
    case 'load':
      return NotificationContentErrorTypes.NotificationContentLoadError;
    default:
      return NotificationContentErrorTypes.NotificationContentServiceUnavailableError;
  }
};
